import { render, staticRenderFns } from "./InputNotes.vue?vue&type=template&id=6f58e7b1&"
import script from "./InputNotes.vue?vue&type=script&lang=js&"
export * from "./InputNotes.vue?vue&type=script&lang=js&"
import style0 from "./InputNotes.vue?vue&type=style&index=0&id=6f58e7b1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports